import { auditReports } from '@mi-front/api-clients';
import { MrtTable } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { LDateTime } from '../../../../../../../components/date/LDateTime';

export function UnverifiedLtxEntriesTable({
  data,
}: {
  data: auditReports.LtxEntryDto[];
}) {
  const { $t } = useIntl();

  return (
    <MrtTable
      data={data}
      columns={[
        {
          id: 'datetime',
          header: $t({
            id: 'audit.reportsScreen.ltxMatches.unverifiedLtxEntries.datetime',
            defaultMessage: 'Fecha y hora',
          }),
          accessorFn: (row) => (row.datetime ? new Date(row.datetime) : null),
          Cell: ({ row }) => <LDateTime value={row.original.datetime} showSeconds />,
          enableSorting: true,
          enableColumnFilter: false,
          filterVariant: 'time-range',
          size: 150,
        },
        {
          id: 'customId',
          header: $t({
            id: 'audit.reportsScreen.ltxMatches.unverifiedLtxEntries.customId',
            defaultMessage: 'Custom ID',
          }),
          accessorKey: 'customId',
          enableSorting: true,
          enableColumnFilter: true,
          filterFn: 'contains',
          size: 150,
        },
        {
          id: 'name',
          header: $t({
            id: 'audit.reportsScreen.ltxMatches.unverifiedLtxEntries.name',
            defaultMessage: 'Nombre',
          }),
          accessorKey: 'name',
          enableSorting: true,
          enableColumnFilter: true,
          filterFn: 'contains',
        },
        {
          id: 'type',
          header: $t({
            id: 'audit.reportsScreen.ltxMatches.unverifiedLtxEntries.type',
            defaultMessage: 'Tipo',
          }),
          accessorKey: 'type',
          enableSorting: true,
          enableColumnFilter: true,
          filterFn: 'equals',
          size: 120,
        },
      ]}
    />
  );
}
